import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { getGTExCardData } from "../../../../state/selectors/GTEx.selectors";
import CardWrapper from "../../CardWrapper";
import Card from "../../Card";

const ExpressionDataCard = ({ card, gtexData }) => {
  const isDisabled = !Object.keys(gtexData || {}).length;

  return (
    <CardWrapper {...card} isDisabled={isDisabled}>
      {gtexData && (gtexData.count || gtexData.highestItem) ? (
        <div data-testid="expression-data-card">
          {gtexData.highestItem ? (
            <div>
              <span>{"Top: "}</span>
              <span className="tw-font-bold" data-testid="gtexTopCount">
                {gtexData.highestItem.expression}
              </span>
            </div>
          ) : null}
          {gtexData.count ? (
            <div>
              <span>{"Tissues: "}</span>
              <span className="tw-font-bold" data-testid="gtexDataCount">
                {gtexData.count}
              </span>
            </div>
          ) : null}
        </div>
      ) : null}
    </CardWrapper>
  );
};

ExpressionDataCard.propTypes = {
  card: PropTypes.instanceOf(Card).isRequired,
  gtexData: PropTypes.shape({
    count: PropTypes.number,
    highestItem: PropTypes.shape({
      expression: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    }),
    exon_id: PropTypes.string,
    exon_number: PropTypes.string,
    expressions: PropTypes.shape({}),
    gencode_id: PropTypes.string,
    gene: PropTypes.string,
    gene_model_positions: PropTypes.shape({
      strand: PropTypes.string,
      start: PropTypes.number,
      chromosome: PropTypes.string,
      end: PropTypes.number,
    }),
    chromosome: PropTypes.string,
    end: PropTypes.number,
    start: PropTypes.number,
    strand: PropTypes.string,
    gene_positions: PropTypes.shape({
      strand: PropTypes.string,
      start: PropTypes.number,
      chromosome: PropTypes.string,
      end: PropTypes.number,
    }),
    absolute_positon: PropTypes.number,
    chromo: PropTypes.string,
    length: PropTypes.number,
    position: PropTypes.number,
  }),
};

ExpressionDataCard.defaultProps = {
  gtexData: {},
};

const mapStateToProps = (state) => ({
  gtexData: getGTExCardData(state),
});

export default connect(mapStateToProps, {})(ExpressionDataCard);
